export default {
  Preface: "Để bắt đầu sử dụng Jetpay vui lòng thực hiện các bước sau",
  SubSystem: {
    systemDeclare: "Thiết lập hệ thống",
    optionDeclare: "Khai báo danh mục",
    assetDeclare: "Khai báo danh sách tài sản",
    assetDeclareSubTitle: "Jetpay hỗ trợ quản lý tài sản theo nhiều cấp.",
  },
  // Thiết lập hệ thống
  System: {
    organizationUnit: "Cơ cấu tổ chức",
    mnagermentUnit: "Đơn vị quản lý tài sản",
    employee: "Danh mục nhân viên",
  },
  // Khai báo danh mục
  Otpion: {
    assetGroup: "Nhóm tài sản",
    assetLocationGroup: "Vị trí tài sản",
    providerGroup: "Nhà cung cấp",
  },
  // Khai báo danh sách tài sản
  AssetSetting: {
    assetType: "Loại tài sản",
    AssetCategories: "Nhóm tài sản",
    asset: "Tài sản",
  },
  DeclareNow: "Khai báo ngay",
  SetupNow: "Thiết lập ngay",
  ImportFromExcel: "Nhập từ Excel",
  DeclareAssetGuide:
    "Các mã tài sản chi tiết được quản lý gom nhóm theo Loại tài sản. Ví dụ: Loại tài sản: Máy tính có các mã MT.001, MT.002.",
  Hello: "Chào",
  Wellcome: "Chào mừng bạn đến với Jetpay",
  Getting: "Bắt đầu sử dụng",
  FailMessage: "Khởi tạo dữ liệu thất bại, vui lòng liên hệ với MISA để được hỗ trợ",

  GuidSubTitle: {
    Organization:
      "Sơ đồ cơ cấu tổ chức, bộ máy doanh nghiệp được cấp phát, sử dụng hoặc quản lý tài sản",
    ManagementUnit:
      "Là các đơn vị quản lý tài sản độc lập với các đơn vị ngang cấp. Tài sản của đơn vị nào do đơn vị đó sử dụng và quản lý",
    Employee:
      "Danh sách toàn bộ nhân viên trong doanh nghiệp có thể nhận cấp phát và sử dụng tài sản",
    AssetLocationCategory: "Danh sách các vị trí, địa điểm của tài sản. Ví dụ: Tầng 1, Tầng 2...",
    Provider: "Danh sách các nhà cung cấp tài sản hoặc nhà cung cấp dịch vụ sửa chữa, bảo dưỡng",
    AssetCategories:
      "Nhóm tài sản bao gồm những Loại tài sản có cùng đặc tính, mục đích sử dụng. Ví dụ: Thiết bị văn phòng, Phương tiện vận tải...",
    AssetType:
      "Loại tài sản bao gồm các mã tài sản cụ thể. Ví dụ: Màn hình máy tính, Chuột máy tính thuộc Nhóm Thiết bị văn phòng",
    Asset:
      "Các mã tài sản chi tiết theo từng Loại tài sản. Ví dụ: Màn hình máy tính 1, Màn hình máy tính 2 thuộc Loại Màn hình máy tính",
  },
};
